import { render, staticRenderFns } from "./Certification.vue?vue&type=template&id=d1293d46&scoped=true"
import script from "./Certification.vue?vue&type=script&setup=true&lang=js"
export * from "./Certification.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Certification.vue?vue&type=style&index=0&id=d1293d46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1293d46",
  null
  
)

export default component.exports